import { render, staticRenderFns } from "./certificateList.vue?vue&type=template&id=61e85f54&scoped=true"
import script from "./certificateList.vue?vue&type=script&lang=js"
export * from "./certificateList.vue?vue&type=script&lang=js"
import style0 from "./certificateList.vue?vue&type=style&index=0&id=61e85f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e85f54",
  null
  
)

export default component.exports